import { CommonModule, Location } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { distinctUntilKeyChanged } from 'rxjs/operators';

import { ConfigService } from '../../config.service';
import { replayLocation } from '../../shared/observable.utils';
import { ProjectListComponent } from '../project-list/project-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FwAvatarModule, FwButtonModule, FwButtonToggleModule, FwCardModule, FwContainedInputModule, FwIconButtonModule, FwIconModule, FwLayoutsModule, FwMenuModule, FwSectionHeadingModule, FwSelectMenuModule, FwSwitchModule, FwTextInputModule } from '@flywheel-io/vision';
import { AdminModule } from 'app/src/admin/admin.module';
import { DirectivesModule } from 'app/src/common/directives.module';
import { ContainerModule } from 'app/src/containers/container.module';
import { FileModule } from 'app/src/files/file.module';
import { MaterialModule } from 'app/src/material.module';
import { ProjectsImportsModule } from 'app/src/project-imports/project-imports.module';
import { SessionModule } from 'app/src/sessions/session.module';
import { PipesModule } from 'app/src/shared/pipes.module';
import { SharedModule } from 'app/src/shared/shared.module';
import { ProjectCatalogComponent } from '../project-catalog/project-catalog.component';

@Component({
  host: {
    'class': 'page-content',
    'test-id': 'project-index',
  },
  selector: 'project-index',
  styles: [`
    .tab-content {
      height: 100%;
    }

    :host::ng-deep.mat-mdc-tab-body-wrapper {
      flex-grow: 1;
    }

    :host {
      width: 100%;
    }
  `],
  template: `
    <header class="content-header">
      <h4 class="vision-h4">{{ 'projectIndex.title' | translate }}</h4>
    </header>

    <mat-tab-group *ngIf="showingTabs; else projectList" [(selectedIndex)]="selectedTabIndex"
      (selectedTabChange)="tabChanged()" mat-stretch-tabs="false" class="content-body tabs-white">
      <mat-tab [label]="'projectIndex.tabs.list' | translate">
        <ng-template matTabContent>
          <ng-container *ngTemplateOutlet="projectList"></ng-container>
        </ng-template>
      </mat-tab>
      <mat-tab [label]="'projectIndex.tabs.catalog' | translate">
        <ng-template matTabContent>
          <project-catalog class="tab-content"></project-catalog>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <ng-template #projectList>
      <project-list [class]="showingTabs ? 'tab-content' : 'content-body'"></project-list>
    <ng-template>
  `,
  standalone: true,
  imports: [
    AdminModule,
    CommonModule,
    ContainerModule,
    DirectivesModule,
    FileModule,
    FormsModule,
    FwAvatarModule,
    FwButtonModule,
    FwButtonToggleModule,
    FwCardModule,
    FwContainedInputModule,
    FwIconButtonModule,
    FwIconModule,
    FwLayoutsModule,
    FwMenuModule,
    FwSectionHeadingModule,
    FwSelectMenuModule,
    FwSwitchModule,
    FwTextInputModule,
    MaterialModule,
    PipesModule,
    ProjectsImportsModule,
    ReactiveFormsModule,
    ScrollingModule,
    SessionModule,
    SharedModule,
    RouterModule,
    ProjectListComponent,
    ProjectCatalogComponent,
  ],
})
export class ProjectIndexComponent implements OnDestroy {
  readonly features = {
    sharedProjects: this.config.isFeatureEnabled('shared_projects'),
  }
  selectedTabIndex = 0

  private subscriptions = {
    location: Subscription.EMPTY,
  }

  constructor(
    private config: ConfigService,
    location: Location,
  ) {
    this.subscriptions.location = replayLocation(location).pipe(
      distinctUntilKeyChanged('url'),
    ).subscribe(() => {
      this.captureRouteState();
    });
  }

  ngOnDestroy(): void {
    for (const subscription of Object.values(this.subscriptions)) {
      subscription.unsubscribe();
    }
  }

  get showingTabs(): boolean {
    return this.features.sharedProjects;
  }

  private captureRouteState(): void {
    // this.selectedTabIndex = this.router.current.name === 'index.projectCatalog' ? 1 : 0;
  }

  tabChanged(): void {
    /*
    const selectedName = this.selectedTabIndex === 1 ? 'index.projectCatalog' : 'index.projects';
    if (this.router.current.name !== selectedName) {
      this.router.go(selectedName, undefined, { notify: false });
    }
    */
  }
}
